const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/financials/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type FinancialsBeforeLoadArgs = {
  context: PermissionContext & {
    flags: {
      loopFinancialsViewEnabled: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};
export const financialsBeforeLoad = async (args: FinancialsBeforeLoadArgs) => {
  await requirePermission('view_loop')(args);
  await requirePermission('view_finance')(args);
  if (!args.context.flags.loopFinancialsViewEnabled) {
    throw redirect({
      to: '/org/$org/loop/$loopId/overview',
      params: args.params,
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/financials/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: financialsBeforeLoad,
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.financials)
    }
  }
});